export { default } from './ScrollTabs';